export default {
  NONE: '',
  TRIALING: 'trialing',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  INCOMPLETE: 'incomplete',
  CANCELlED: 'cancelled',
};
